import isUndefined from "lodash/isUndefined";
import api from "PFCore/api";
import { Conversation, GId, Id } from "PFTypes";

export type FetchConversationsPayload = {
  target?: GId;
  term?: string;
  perPage?: number;
  page?: number;
  empty?: boolean;
  me?: boolean;
  oneToOneProfileId?: Id;
};

export type FetchConversationsResponse = {
  entries: Conversation[];
  meta: { total: number };
};

export const fetchConversations = ({
  target,
  term = "",
  empty,
  me,
  oneToOneProfileId,
  page = 1,
  perPage = 15
}: FetchConversationsPayload = {}): Promise<FetchConversationsResponse> =>
  api({
    url: "chat/conversations",
    params: {
      ...(target && { target }),
      ...(!isUndefined(empty) && { empty }),
      ...(!isUndefined(me) && { me }),
      ...(term && { term }),
      ...(oneToOneProfileId && { oneToOneProfileId }),
      page,
      perPage
    }
  });
